<template>
  <div class="fa-div">
    <!--    <Card class="card">-->
    <!--      <Row type="flex" align="middle">-->
    <!--        <Col span="" class="menubtton">-->
    <!--          &lt;!&ndash; <span style="width: 64%">角色名称：</span> &ndash;&gt;-->
    <!--          <Input v-model="selectData.name" placeholder="角色名称"></Input-->
    <!--        ></Col>-->
    <!--        <Col class="inquire" offset="8">-->
    <!--          <Button type="error" :loading="selectLoading" @click="selectEvent()"-->
    <!--            >搜索</Button-->
    <!--          >-->
    <!--        </Col>-->
    <!--        <Col span="2">-->
    <!--          <Button @click="resetEvent()">重置</Button>-->
    <!--        </Col>-->
    <!--      </Row>-->
    <!--      <Row style="margin-top: 12px">-->
    <!--        <Col span="2">-->
    <!--          <Button type="error" @click="addbtn" v-has="'WSS-6002-create'"-->
    <!--            >新增</Button-->
    <!--          >-->
    <!--        </Col>-->
    <!--        <Col span="2">-->
    <!--          <Button type="error" @click="editBTN" v-has="'WSS-6002-edit'"-->
    <!--            >修改</Button-->
    <!--          >-->
    <!--        </Col>-->
    <!--        <Col>-->
    <!--          <Button type="error" @click="delBTN" v-has="'WSS-6002-remove'"-->
    <!--            >删除</Button-->
    <!--          >-->
    <!--        </Col>-->
    <!--      </Row>-->
    <!--    </Card>-->
    <div class="roleTop">
      <div class="flex">
        <Input
          class="w200"
          v-model="selectData.name"
          :placeholder="$t('Role.Name')"
        ></Input>
        <Button
          class="ml10"
          type="primary"
          :loading="selectLoading"
          @click="selectEvent()"
          >{{$t('Role.search')}}</Button
        >
        <Button class="ml10" type="primary" @click="resetEvent()">{{$t('Role.reset')}}</Button>
      </div>
    </div>
    <div class="roleBottom">
      <div class="mb10">
        <Button type="info" @click="addbtn" v-has="'WSS-6002-create'" ghost
          >{{$t('Role.Add')}}</Button
        >
        <Button
          type="info"
          class="ml10"
          @click="editBTN"
          v-has="'WSS-6002-edit'"
          ghost
          >{{$t('Role.Revise')}}</Button
        >
        <Button
          type="info"
          class="ml10"
          @click="delBTN"
          v-has="'WSS-6002-remove'"
          ghost
          >{{$t('Role.delete')}}</Button
        >
      </div>
      <div class="fa-divs">
        <div class="flexVxe">
          <!-- 表单 -->
          <vxe-table
            ref="xTable"
            border
            resizable
            highlight-current-row
            highlight-hover-row
            :data="tableData"
            align="center"
            :loading="loading2"
            style="max-width: 1000px"
            @current-change="currentChangeEvent"
          >
            <!-- <vxe-column minWidth="80" type="radio" title="操作"></vxe-column> -->
            <vxe-column type="seq" :title="$t('Role.number')" width="80"></vxe-column>
            <vxe-column field="name" width="180" :title="$t('Role.Name')"></vxe-column>
            <vxe-column width="200" field="createUname" :title="$t('Role.create')">
              <template #default="{ row }">
                <div>{{ row.createUname }}</div>
                <div>{{ row.createTime }}</div>
              </template>
            </vxe-column>
            <vxe-column width="200" field="createTime" :title="$t('Role.Edit')">
              <template #default="{ row }">
                <div>{{ row.updateUname }}</div>
                <div>{{ row.updateTime }}</div>
              </template>
            </vxe-column>
          </vxe-table>
          <!-- 分页 -->
          <div class="pageClass">
            <div class="pageTotalClass">
              <span>共{{ pager.total }}条数据</span>
            </div>
            <!--              :total="pager.total"-->
            <!-- <vxe-pager
              align="right "
              size="mini"
              ref="vxePager"
              :current-page.sync="pager.current"
              :page-size.sync="pager.size"
              :page-sizes="[30]"
              @page-change="handlePageChange"
              :layouts="[
                // 'Total',
                'PrevJump',
                'PrevPage',
                'Number',
                'NextPage',
                'NextJump',
                'Sizes'
                // 'FullJump',
              ]"
            >
            </vxe-pager> -->

            <div
              style="display: flex; justify-content: right; padding-right: 5px"
            >
              <vxe-pager
                align="right "
                size="mini"
                ref="vxePager"
                :current-page.sync="pager.current"
                :page-size.sync="pager.size"
                :page-sizes="[30]"
                @page-change="handlePageChange"
                :layouts="[
                  // 'Total',
                  'PrevJump',
                  'PrevPage',
                  'Number',
                  'NextPage',
                  'NextJump',
                  'Sizes'
                  // 'FullJump',
                ]"
              >
              </vxe-pager>
              <span
                style="
                  height: 31px;
                  padding: 7px 10px;
                  border: 1px solid rgb(220, 222, 226);
                  border-radius: 4px;
                  margin-top: 2px;
                  line-height: 13px;
                "
                >30条/页</span
              >
            </div>
          </div>
        </div>
        <!-- 修改 -->
        <div class="modal-div">
          <!-- <div> -->
          <div class="editBTNS">
            <!--             <div class="modal-div-1" v-show="spinShow"> -->
            <!-- <Button type="error" @click="redact" v-show="ISshow">编辑</Button> -->
            <Button type="primary" @click="saveBTN" style="margin-right: 10px"
              >{{$t('Role.save')}}</Button
            >
            <!-- <Button @click="cancelBTN" v-show="!ISshow">取消</Button> -->
          </div>
          <div class="modal-div-p">
            <p>{{$t('Role.Permission')}}</p>
            <!-- <fieldset :disabled="isdisabled"> -->
            <Tree
              ref="tree"
              :data="data2"
              :show-checkbox="ischeck"
              :render="renderContent"
              @on-check-change="checkBTN"
            ></Tree>
            <!-- </fieldset> -->
          </div>
          <!-- 加载中 -->
          <!-- <Row>
              <Col class="demo-spin-col">
                <Spin fix v-show="!spinShow">加载中...</Spin>
              </Col>
            </Row> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <Modal
      :mask-closable="false"
      v-model="Model"
      :title="isAdd ? '新增角色' : '修改角色'"
      width="400"
      :closable="false"
    >
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="角色名称：" prop="name">
          <Input v-model="formValidate.name"></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <Button type="primary" @click="btnOK('formValidate')" :loading="loading"
          >确定</Button
        >
        <Button @click="btnCANCEL">取消</Button>
      </div>
    </Modal>
    <!-- 删除员工 -->
    <Modal
      v-model="Model1"
      title="提示"
      width="400"
      :closable="false"
      :mask-closable="false"
    >
      <h2>您确认删除此角色吗？</h2>
      <div slot="footer" style="text-align: center">
        <Button type="primary" @click="delok" :loading="loading1">确定</Button>
        <Button @click="delCANCEL">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// import menuButton from './conponents/menuBUtton'
// import add from './add.vue'
// import dataRange from './components/dataRange'
import { dataMixin } from './datamixin.js'
// import {
//   getcombodata,
//   savedata,
//   DropDown,
//   getbranddata
// } from '../../../api/organization/roleManagement'
export default {
  mixins: [dataMixin],
  components: {
    // menuButton
    // dataRange,
  },
  data() {
    return {
      isdisabled: false, // 审核不通过禁用
      ischeck: true,
      // spinShow: false,
      // ISshow: true,
      loading2: false,
      Model: false,
      Model1: false,
      loading: false,
      loading1: false,
      // model1: '',
      // combo: '', // 套餐
      // modal2: false,
      // tableData: [],
      // switch1: false,
      selectLoading: false,
      saveLoading: false,
      menuLoading: false,
      sings: false,
      formValidate: {
        name: ''
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '角色名称不能为空！',
            trigger: 'blur'
          },
          {
            type: 'string',
            max: 20,
            message: '最多20个字',
            trigger: 'blur'
          }
        ]
      },
      tabledata: [],
      curStr: '',
      bs2: null,
      boxHArr: [],
      brandsonlist: [],
      pager: {
        current: 1,
        size: 30,
        total: 0
      }
    }
  },

  created() {},
  methods: {},
  watch: {}
}
</script>

<style lang="less" scoped>
@import './index.less';
fieldset[disabled] {
  -ms-pointer-events: none;
  pointer-events: none;
}
fieldset {
  border: 0;
}
</style>
